import { useSettingsStore } from 'Store/settings'
import { useChatStore } from 'Store/chat'
import { useCustomerSegmentStore } from 'Store/customer-segment'
import { useReservationForm } from 'Store/reservation-form'
import { useAppStore } from 'Store/app'

export function openBookingWidget(params = {}, bwDOMEvent) {
  const settingsStore = useSettingsStore()
  const chatStore = useChatStore()
  const customerSegmentStore = useCustomerSegmentStore()
  const reservationFormStore = useReservationForm()
  const appStore = useAppStore()

  const { startDate, endDate, adults } = reservationFormStore

  let searchParams = { ...params }
  if (customerSegmentStore.searchParams) {
    searchParams = customerSegmentStore.searchParams
  }

  if (customerSegmentStore.activeIconMessage) {
    searchParams.segment_ids = customerSegmentStore.activeIconMessage.segmentIds
    searchParams.icon_message_id = customerSegmentStore.activeIconMessage.iconMessageID
  }

  let cdpAttr = {}
  if (customerSegmentStore?.activeIconMessage?.iconMessageID) {
    const { iconMessageID, segmentIds, title } = customerSegmentStore.activeIconMessage
    if (iconMessageID && segmentIds) {
      cdpAttr = {
        utm_source: 'tripla Connect',
        utm_medium: 'icon message',
        utm_campaign: title
      }
    } else if (iconMessageID) {
      cdpAttr = {
        utm_source: 'tripla_bot',
        utm_medium: 'icon_auto_message',
        utm_campaign: iconMessageID
      }
    }
  }

  if (searchParams.action === 'room_reservation') {
    cdpAttr = {
      utm_source: 'tripla_bot',
      utm_medium: 'menu',
      utm_campaign: null
    }
  } else {
    cdpAttr = {
      utm_source: 'tripla_bot',
      utm_medium: 'action_auto_message',
      utm_campaign: appStore?.autoMessageAuthId ? `${appStore.autoMessageAuthId}` : null
    }
  }

  if (searchParams.checkin) {
    searchParams.checkin = searchParams.checkin.replace(/-/g, '/')
  }

  if (searchParams.checkout) {
    searchParams.checkout = searchParams.checkout.replace(/-/g, '/')
  }

  if (searchParams.kids_tiers) {
    try {
      searchParams.kids_tiers = JSON.parse(searchParams.kids_tiers)
    } catch (e) {
      delete searchParams.kids_tiers
    }
  }

  if (settingsStore.isCustomBotTestMode) {
    searchParams.custom_bot_test = settingsStore.isCustomBotTestMode
  }

  window.OpenBookingWidgetFromChatbot(
    {
      checkIn: startDate.replace(/-/g, '/'),
      checkOut: endDate.replace(/-/g, '/'),
      adults,
      chatID: chatStore.chatId,
      ...cdpAttr,
      ...searchParams
    },
    settingsStore.isBrandFacility ? 'openTriplaBrandFacilities' : bwDOMEvent
  )

  customerSegmentStore.setActiveIconMessage(null)
  appStore.setAutoMessageAuthId(null)
  appStore.setAutoMessageAuthType(null)
}
